import {
    Component,
    EventEmitter,
    Inject,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { CommitmentKpi, GoalStatus } from '../../coaching-base/general';
import { SortDirection } from '../../coaching-insight/oa/models/sorting.model';
import { TranslationKeyMap } from '../coaching-commitment.i18n';
import { GoalFormValue } from '../commitment-goals/goals.commitment.form';
import { CommitmentGoalHistory } from '../models/commitment-goal-history.model';

import { goalHistoryMap } from './history.goal.commitment.function';

@Component({
    selector: 'cmps-goal-history-commitment',
    templateUrl: './history.goal.commitment.component.html',
    host: {
        class: 'cmps-goal-history-commitment',
    },
})
export class GoalHistoryCommitmentComponent implements OnChanges, OnInit {
    @Output() onChangeSelectedGoal: EventEmitter<CommitmentKpi>;
    @Output() onSort: EventEmitter<SortDirection>;

    /** @private */ _dataSource: CommitmentGoalHistory[];

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _GoalStatus = GoalStatus;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            GoalHistoryCommitmentComponent,
            void
        >,
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _data: {
            goal: GoalFormValue;
            history: CommitmentGoalHistory[];
        },
    ) {
        this.onChangeSelectedGoal = new EventEmitter();
        this.onSort = new EventEmitter();
    }

    ngOnInit(): void {
        this.loadDataSource();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('history')) {
            this.loadDataSource();
        }
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('goal')) {
            this.loadDataSource();
        }
    }

    loadDataSource(): void {
        this._dataSource = goalHistoryMap(this._data?.history);
    }
}
